<template>
  <div>
    <div class="nav-bar">
      <top-nav title="卡券详情"/>
    </div>
    <div class="main">
      <van-notice-bar color="#1989fa" background="#ecf9ff">
        卡券信息
      </van-notice-bar>
      <van-cell-group>
        <van-cell title="活动商户" :value="cardDetail.store_name" />
        <van-cell title="卡券编号" :value="cardDetail.card_num" />
        <van-cell title="卡券名称" :value="cardDetail.title" />
        <van-cell title="卡券颜色" :value="cardDetail.color" />
        <van-cell title="卡券类型" :value="cardDetail.card_type" />
        <van-cell title="发券数量" :value="cardDetail.num" />
        <van-cell title="卡券介绍" :label="cardDetail.description" />
        <van-cell title="限制领取数量" :value="cardDetail.get_limit" />
        <van-cell title="消费者满多少" :value="cardDetail.consumer_full_money" />
        <van-cell title="消费者减多少" :value="cardDetail.consumer_reduce_money" />
        <van-cell title="商户优惠" :value="cardDetail.merchant_reduce_money" />
        <van-cell title="客服电话" :value="cardDetail.phone" />
        <van-cell title="卡券有效期类型" :value="cardDetail.limit_date_type" />
        <van-cell title="卡券创建日期" :value="cardDetail.create_time" />
        <van-cell title="固定卡券生效日期" :value="cardDetail.limit_began_date" />
        <van-cell title="固定卡券失效日期" :value="cardDetail.limit_end_date" />
        <van-cell title="领取开始时间" :value="cardDetail.get_began_date" />
        <van-cell title="领取结束时间" :value="cardDetail.get_end_date" />
      </van-cell-group>
    </div>
  </div>
</template>
<script>
import tapNav from "@/components/navBar";
export default {
  data() {
    return {
        cardDetail:{}
    };
  },
  components: {
    topNav: tapNav,
  },
  methods: {},
  mounted() {
    console.log(this.$route.query);
    this.cardDetail = this.$route.query;
    // console.log(JSON.parse(this.$route.query));
  },
};
</script>
<style scoped>
</style>